module.exports = __webpack_public_path__ + "img/TABLE_UPDATE.6802c860.png";